import type { ReactElement } from 'react';

import { BpkStackedLogo } from '@skyscanner-internal/bpk-logos';

import STYLES from './PageNotFoundHeader.module.scss';

const PageNotFoundHeader = (): ReactElement => (
  <header className={STYLES['page-not-found-header']}>
    <BpkStackedLogo className={STYLES['page-not-found-header__logo']} aria-hidden="true" />
    <span className={STYLES['page-not-found-header__hidden-text']}>Skyscanner</span>
  </header>
);

export default PageNotFoundHeader;
